import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {Vec3} from '../types/global';

export interface UIState {
  sidebarOpen: boolean;
  sidebarWidth: number;
  darkMode: boolean;
  orientation: 'landscape' | 'portrait';
  tappedCoord: Vec3 | null;
}

const initialState: UIState = {
  sidebarOpen: false,
  sidebarWidth: 300,
  darkMode: true,
  orientation: 'landscape',
  tappedCoord: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen(state, action: PayloadAction<boolean>) {
      state.sidebarOpen = action.payload;
    },
    setSidebarWidth(state, action: PayloadAction<number>) {
      state.sidebarWidth = action.payload;
    },
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
    },
    setOrientation(state, action: PayloadAction<'landscape' | 'portrait'>) {
      state.orientation = action.payload;
    },
    setTappedCoord: (state, action: PayloadAction<Vec3 | null>) => {
      state.tappedCoord = action.payload;
    },
  },
});

export const uiActions = uiSlice.actions;
export default uiSlice.reducer;
